// Resolve an event's actor to the person's real name via the workspace roster.
//
// Sign-in events written by sessions that carried no name claims fell back to
// the capitalised email prefix ("ytsadok@gmail.com" -> "Ytsadok") — or, for
// sessions from the old demo fallback, to whatever was typed before the @
// ("rep", "owner"). The roster knows who these people actually are, so display
// goes through it and the stored label is only the last resort.
import { listMembers } from './team.js'

let cache = null
let at = 0
const TTL = 5 * 60 * 1000

export async function loadActorNames() {
  if (cache && Date.now() - at < TTL) return cache
  try {
    const { members } = await listMembers()
    cache = new Map(
      (members || [])
        .filter((m) => m.email && m.name)
        .map((m) => [String(m.email).trim().toLowerCase(), m.name]),
    )
  } catch {
    cache = cache || new Map()
  }
  at = Date.now()
  return cache
}

// Synchronous once the map is loaded; pass the map from loadActorNames().
export function resolveActor(map, email, storedName) {
  const fromRoster = map?.get(String(email || '').trim().toLowerCase())
  return fromRoster || storedName || email || ''
}
